import React, { FC } from 'react'
import { DividerContainer } from './style'

//* utils
import { ComponentDivider } from '../../../models/components/divider'
import ImgUtil from '../../../utils/img.utils'
import { internalLinkHandler } from '../../../utils/link.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'
import Typography from '../typography'

//* components
import Button from '../button'
import WrapperImage from '../wrapperImage'

type Props = {
  data: ComponentDivider
}

const Divider: FC<Props> = ({ data }) => {
  if (!data) return null
  const image = {
    url: data.image?.image?.file?.url || '',
    alt: data.image?.altText || '',
  }

  const divider = {
    heading: data.headline || '',
    subheadline: data.subheadline || '',
    cta: data.dividerCta || {},
    theme: data.theme || 'Light',
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'Large',
    useCase: data.useCase,
  }

  const buttonHref = divider.cta?.internalLink
    ? internalLinkHandler(divider.cta.internalLink)
    : divider.cta?.externalUrl || '/'

  return (
    <DividerContainer
      $componentTheme={divider.theme}
      $bottomPadding={divider.bottomPadding}
      $topPadding={divider.topPadding}
      data-cy="divider">
      <div
        className={`Divider__Inner ${data.useCase === 'Full width' ? 'fullWidth__divider' : ''}`}>
        <div className="Divider__Image-Container">
          <WrapperImage
            className="Divider__Image"
            loading="lazy"
            alt={image.alt}
            src={ImgUtil.getResizedImageUrl(image.url, '')}
            width={1440}
            height={540}
            threshold={650}
          />
        </div>

        <div className="Divider__Text">
          <div className="Divider__Text-Inner">
            <Typography className="Divider__Heading" type="header2">
              {formatInlineCode(divider.heading)}
            </Typography>

            {divider.subheadline && (
              <Typography className="Divider__Subheading font__inter" type="bodyXL">
                {renderRichText(divider.subheadline)}
              </Typography>
            )}

            {divider.cta?.ctaText && (
              <Button
                icon={true}
                href={buttonHref}
                text={divider.cta.ctaText}
                type="text-link"
                size="small"
                theme="light"
              />
            )}
          </div>
        </div>
      </div>
    </DividerContainer>
  )
}

export default Divider
